// extracted by mini-css-extract-plugin
export default {"buttonGroup":"QRCodePopup_buttonGroup__7Nbar","text":"QRCodePopup_text__xUDJX"};